import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export function About() {
  const { t } = useLanguage();

  return (
    <section id="about" className="about">
      <div className="about__container">
        {/* Main Title */}
        <div className="about__header">
          <h2 className="about__title">{t('about.title')}</h2>
          <p className="about__subtitle">{t('about.subtitle')}</p>
        </div>

        {/* Birth History */}
        <div className="about__section">
          <p className="about__text">{t('about.history.birth')}</p>
        </div>

        {/* Dream Story */}
        <div className="about__section">
          <h3 className="about__section-title">{t('about.dream.title')}</h3>
          <p className="about__text">{t('about.dream.story')}</p>
          <p className="about__text about__text--quote">{t('about.dream.vision')}</p>
          <p className="about__text">{t('about.dream.result')}</p>
        </div>

        {/* Temple Structure */}
        <div className="about__section">
          <h3 className="about__section-title">{t('about.temple.title')}</h3>
          <p className="about__text">{t('about.temple.history')}</p>
        </div>

        {/* Deities */}
        <div className="about__section">
          <h3 className="about__section-title">{t('about.deities.title')}</h3>
          <p className="about__text about__text--list">{t('about.deities.list')}</p>
        </div>

        {/* Faith Quote */}
        <div className="about__section about__section--highlight">
          <h3 className="about__section-title">{t('about.faith.title')}</h3>
          <p className="about__text about__text--quote">{t('about.faith.quote')}</p>
        </div>

        {/* Admin */}
        <div className="about__section">
          <h3 className="about__section-title">{t('about.admin.title')}</h3>
          <p className="about__text"><strong>{t('about.admin.name')}</strong></p>
          <p className="about__text">{t('about.admin.desc')}</p>
        </div>

        {/* Conclusion */}
        <div className="about__section about__section--conclusion">
          <p className="about__text about__text--large">{t('about.conclusion')}</p>
        </div>
      </div>
    </section>
  );
}